export default "__VITE_ASSET__266cd74b__"